import { render, staticRenderFns } from "./addQuestionnaire.vue?vue&type=template&id=cbc2fd3c&scoped=true&"
import script from "./addQuestionnaire.vue?vue&type=script&lang=ts&"
export * from "./addQuestionnaire.vue?vue&type=script&lang=ts&"
import style0 from "./addQuestionnaire.vue?vue&type=style&index=0&id=cbc2fd3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc2fd3c",
  null
  
)

export default component.exports